/** In-app legal document routes (overridable via VITE_PORTAL_*_URL env). */
export const PortalLegalRoute = {
  PRIVACY_POLICY: '/legal/privacy-policy',
  TERMS_AND_CONDITIONS: '/legal/terms-and-conditions',
} as const;
